<template>
  <div class="id-tag">

    <!-- START ID Tag -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-smart-card" title="ID Tag" text-color="title" />
            <div class="row mt-2" id="datatable_wrapper">
              <div class="col-lg-12">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input v-model="filter"
                                  type="search"
                                  placeholder="Search..."
                                  class="form-control form-control-sm ms-2" />
                  </label>
                </div>
              </div>
            </div>

            <div class="id-tag-table">
              <b-table class="datatables text-nowrap" hover
                       :fields="fields" :items="items"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       :filter="filter"
                       :filter-included-fields="filterOn"
                       @row-clicked="idTagView"
                       @row-dblclicked="idTagEdit">
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>

            <div class="row mt-2">
              <div class="col-lg-12 text-align-end">
                <b-button class="w-sm" size="sm" variant="primary" @click="idTagCreateModal = true">
                  <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
                  <span>Register</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <card-title icon-image="mdi-database" title="ID Tag Data" text-color="title" />
            <div class="id-tag-data-table">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th scope="col" class="w-50">Item</th>
                  <th scope="col" class="w-50">Value</th>
                </tr>
                </thead>
                <tbody v-if="$_utils.isEmpty(item.idTag)">
                <tr>
                  <td class="text-nowrap" scope="row" colspan="2">ID Tag 를 선택하세요.</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="it in jqlApi.schema" v-if="!$_utils.isEmpty(it.key)">
                  <th class="text-nowrap" scope="row">{{ it.label }}</th>
                  <td>{{ item[it.key] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END ID Tag -->

    <!-- START ID Tag Create Modal -->
    <b-modal v-model="idTagCreateModal" centered
             header-bg-variant="primary">
      <template #modal-header>
        <div class="text-white">ID Tag Registration</div>
      </template>
      <div>
        <MDKForm ref="_form" :fields="formFields" :entity="{}" />
      </div>
      <template #modal-footer>
        <div class="w-100 text-align-end">
          <b-button class="w-sm ct-margin-right-100" size="sm" variant="secondary"
                    @click="idTagCreateModal = false">
            <i class="fas fa-times icon-padding-right ct-mb-padding-left-25" />
            <span class="d-none d-sm-inline-block">Close</span>
          </b-button>
          <b-button class="w-sm" size="sm" variant="primary"
                    @click="createIdTag">
            <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
            <span>Save</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END ID Tag Create Modal -->

    <!-- START ID Tag Edit Modal -->
    <b-modal v-model="idTagEditModal" centered
             header-bg-variant="primary">
      <template #modal-header>
        <div class="text-white">ID Tag Edit</div>
      </template>
      <div>
        <MDKForm ref="_form" :fields="formFields" :entity="selectedRow ? selectedRow : {}" />
      </div>
      <template #modal-footer>
        <div class="w-100 text-align-end">
          <b-button class="w-sm ct-margin-right-100" size="sm" variant="secondary"
                    @click="idTagEditModal = false">
            <i class="fas fa-times icon-padding-right ct-mb-padding-left-25" />
            <span class="d-none d-sm-inline-block">Close</span>
          </b-button>
          <b-button class="w-sm" size="sm" variant="primary"
                    @click="editIdTag">
            <i class="fas fa-edit icon-padding-right ct-mb-padding-left-25" />
            <span>Edit</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END ID Tag Edit Modal -->

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.idTag;
    return {
      jqlApi: _api,
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'idTag', label: 'ID Tag', sortable: true },
        { key: 'parentIdTag', label: 'Parent ID Tag', sortable: true },
        { key: 'created', label: '등록일', sortable: true }
      ],
      items: [],
      filter: null,
      filterOn: [],
      sortBy: 'created',
      sortDesc: true,
      formFields: [
        _api.schema.idTag,
        _api.schema.parentIdTag,
        _api.schema.expiryDate,
        _api.schema.maxActiveTransactionCount
      ],
      idTagCreateModal: false,
      idTagEditModal: false,
      selectedRow: null,
      item: {}
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems() {
      const vm = this;

      vm.jqlApi.list()
          .then(res => {
            console.log('resddd', res)
            vm.items = res;
          }).catch(err => {
        console.log(err);
      });
    },
    createIdTag() {
      const vm = this;
      const entity = vm.$refs._form.getUpdatedProperties();

      if (!this.$_utils.isEmpty(entity.expiryDate)) {
        entity.expiryDate += ' 23:59:59'
      }

      vm.jqlApi.add(entity)
          .then(res => {
            vm.idTagCreateModal = false;
            this.$swal('등록 완료', '등록이 완료되었습니다.', 'success')
            vm.getItems();
          }).catch(err => {
        console.log(err)
        this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
      });
    },
    editIdTag() {
      const vm = this;
      const entity = vm.$refs._form.getUpdatedProperties();

      if (!this.$_utils.isEmpty(entity.expiryDate)) {
        entity.expiryDate += ' 23:59:59'
      }

      vm.jqlApi.updateByIdList(vm.selectedRow.id, entity)
          .then(res => {
            vm.idTagEditModal = false;
            this.$swal('수정 완료', '수정이 완료되었습니다.', 'success')
            vm.getItems();
          }).catch(err => {
        console.log(err)
        this.$swal('수정 실패', '수정이 실패하였습니다.', 'error')
      });
    },
    idTagView(row) {
      const vm = this;
      vm.selectedRow = row;

      vm.jqlApi.findById(vm.selectedRow.id)
          .then(res => {
            vm.item = Object.assign({}, res);
          }).catch(err => {
        console.log(err)
      });
    },
    idTagEdit(row) {
      const vm = this;

      vm.selectedRow = row;
      vm.idTagEditModal = true;
    }
  }
}
</script>
